const renderPresets = {
    'video': function(data) {
        const html = data.map(({url, thumbnail, title, description, duration, views, date}) => (
            `<li class="presentation__wrapper">
              <div class="presentation">
               
                <a class="presentation__contents" href="${url}" target="blank">
                  <div class="presentation__thumbnail-wrapper">
                      <img src="${thumbnail}" alt="Digital Media thumbnail for ${title}" class="presentation__thumbnail" />
                      <div class="presentation__duration">${duration}</div>
                  </div>
                  <div class="presentation__caption">${title}</div>
                  <div class="presentation__date">${date} &#183; ${views} ${views == 1 ? 'views':'view'}</div>

                </a>
              </div>
            </li>`
        ));
        return html.join('');
    },
    'etui-video': function(data) {
        const html = data.map(({url, thumbnail, title, description, duration, views, date}) => (
            `<div class="col-md-3 mb-4">
                <a class="presentation__contents etui link-reset text-decoration-none" href="${url}" target="blank">
                    <div class="card external h-100 image-divider title-sm">
                        <img
                            class="card-img-top"
                            src="${thumbnail}"
                            alt="Digital Media thumnail for ${title}"
                            style="height: 225px; object-fit: cover;"
                        >
                        <div class="card-body">
                            <div class="card-title">${title}</div>
                            <div class="card-text">
                                <div>Duration: ${duration}</div>
                                ${date} &#183;
                                ${views} ${views == 1 ? 'view':'views'}
                            </div>
                        </div>
                    </div>
                </a>
            </div>`
        ));
        return `<div id="recentvideos" class="row">${html.join('')}</div>`;
    },

};

function init(opts) {
    var container = $(opts.paginationSelector);
    container.pagination({
        dataSource: opts.data,
        pageSize: opts.pageSize,
        callback: function(data, pagination) {
            var renderer = opts.renderType ? renderPresets[opts.renderType] : opts.render;
            var html = renderer(data);
            const containerEl = document.querySelector(opts.dataSelector);
            containerEl.innerHTML = html;
        }
    });
}

global.paginate = {
    init: init
}